// src/components/layout/BottomNav.js
// Profile moved out of the bottom nav (now the top-right avatar on every
// screen). Five tabs: Events, Community, Services, Skill Share, Support.
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV = [
  { label: 'Events',      icon: '📅', path: '/' },
  { label: 'Community',   icon: '🤝', path: '/community' },
  { label: 'Services',    icon: '🏘️', path: '/services' },
  { label: 'Skill Share', icon: '✨', path: '/skills' },
  { label: 'Support',     icon: '❤️', path: '/support-your-town' },
];

const GATHER_GREEN = '#1A7A4A';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav style={styles.nav} aria-label="Main navigation">
      {NAV.map(item => {
        const active = location.pathname === item.path ||
          (item.path === '/' && location.pathname === '/');
        return (
          <button
            key={item.path}
            style={styles.item}
            onClick={() => navigate(item.path)}
            aria-current={active ? 'page' : undefined}
          >
            <span style={styles.icon}>{item.icon}</span>
            <span style={{
              ...styles.label,
              color: active ? GATHER_GREEN : '#9CA3AF',
              fontWeight: active ? 800 : 600,
            }}>
              {item.label}
            </span>
            {active && <span style={styles.activeDot} />}
          </button>
        );
      })}
    </nav>
  );
};

const styles = {
  nav: {
    position: 'fixed',
    bottom: 0, left: '50%',
    transform: 'translateX(-50%)',
    width: '100%', maxWidth: 430,
    height: 'var(--nav-height)',
    background: '#FFFFFF', borderTop: '1px solid #F0F0F0',
    boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 10,
    zIndex: 100,
  },
  item: {
    flex: 1,
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', gap: 3,
    padding: '4px 0',
    background: 'none', border: 'none',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    position: 'relative',
  },
  icon: { fontSize: 20, lineHeight: 1 },
  label: {
    fontSize: 9,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
    fontFamily: 'Nunito, sans-serif',
  },
  activeDot: {
    position: 'absolute',
    top: -10,
    width: 3, height: 3,
    borderRadius: '50%',
    background: '#1A7A4A',
  },
};

export default BottomNav;
